module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lLog1"))).then(() => parcelRequire('hEqeo'));